var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickStartProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.875 1.53125C2.81836 1.53125 1.21875 3.20703 1.21875 5.1875V29.5625C1.21875 31.6191 2.81836 33.2188 4.875 33.2188H29.25C31.2305 33.2188 32.9062 31.6191 32.9062 29.5625V5.1875C32.9062 3.20703 31.2305 1.53125 29.25 1.53125H4.875ZM0 5.1875C0 2.52148 2.13281 0.3125 4.875 0.3125H29.25C31.916 0.3125 34.125 2.52148 34.125 5.1875V29.5625C34.125 32.3047 31.916 34.4375 29.25 34.4375H4.875C2.13281 34.4375 0 32.3047 0 29.5625V5.1875ZM7.61719 26.8203C7.3125 26.5156 7.23633 26.0586 7.3125 25.6016L8.45508 21.0312C8.53125 20.6504 8.75977 20.2695 9.06445 19.8887L20.9473 8.08203C22.166 6.86328 24.0703 6.86328 25.2891 8.08203L26.3555 9.14844C27.5742 10.3672 27.5742 12.2715 26.3555 13.4902L14.4727 25.2969C14.168 25.6016 13.7871 25.8301 13.4062 25.9824L8.75977 27.125C8.37891 27.2012 7.92188 27.125 7.61719 26.8203ZM25.5176 12.6523C26.2031 11.8906 26.2031 10.748 25.5176 10.0625L24.375 8.91992C23.6895 8.23438 22.5469 8.23438 21.7852 8.91992L19.8809 10.9004L23.5371 14.5566L25.5176 12.6523ZM13.6348 24.459L22.6992 15.3945L19.043 11.7383L9.97852 20.8027C9.82617 20.9551 9.67383 21.1074 9.67383 21.3359L8.83594 24.6113L8.53125 25.9062L9.82617 25.6016L13.1016 24.7637C13.2539 24.7637 13.4824 24.6113 13.6348 24.459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickStartProposal);
export default __webpack_public_path__ + "static/media/quick_start_proposal.5e934bda2faea1846c7120ed6a04dd6c.svg";
export { ForwardRef as ReactComponent };